export const UPDATE_CREATIVE_GROUP_SYNC = 'UPDATE_CREATIVE_GROUP_SYNC';
export const UPDATE_CREATIVE_SYNC = 'UPDATE_CREATIVE_SYNC';

export const updateCreativeGroupSync = groupData => ({
  type: UPDATE_CREATIVE_GROUP_SYNC,
  groupData
});

// TODO: implement this including http request
export const updateCreativeGroupAsync = () => {};

export const updateCreativeSync = creativeData => ({
  type: UPDATE_CREATIVE_SYNC,
  creativeData
});
